import { useFocusEffect } from '@react-navigation/native'
import { useCallback } from 'react'
import { VoidFunction } from '../types'

export const useFocusRefetch = (onRefetch: VoidFunction) => {
    const onRefetchCallback = useCallback(onRefetch, [])

    useFocusEffect(onRefetchCallback)
}
